import { render, staticRenderFns } from "./PanelWithBranchInformation.vue?vue&type=template&id=6ac21f9b&lang=pug&"
import script from "./PanelWithBranchInformation.vue?vue&type=script&lang=ts&"
export * from "./PanelWithBranchInformation.vue?vue&type=script&lang=ts&"
import style0 from "./PanelWithBranchInformation.vue?vue&type=style&index=0&id=6ac21f9b&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports